import { trans } from "@mongez/localization";
import { useCurrentPaymentMethod, usePaymentMethods } from "../hooks";
import { PaymentMethodCard } from "./PaymentMethodCard";

export const PaymentMethodsGrid = () => {
  const { paymentMethodsList } = usePaymentMethods();
  const { paymentMethod, changePaymentMethod } = useCurrentPaymentMethod();

  // If no payment methods available, show message
  if (paymentMethodsList.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <p className="text-center text-gray-500 dark:text-gray-400">
          {trans("payment.noPaymentMethodsAvailable")}
        </p>
      </div>
    );
  }

  // Determine grid classes based on number of payment methods with larger cards
  const getGridClasses = () => {
    if (paymentMethodsList.length === 1) {
      return "grid grid-cols-1 gap-6 max-w-lg mx-auto";
    } else if (paymentMethodsList.length === 2) {
      return "grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto";
    } else if (paymentMethodsList.length === 3) {
      return "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto";
    } else {
      return "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto";
    }
  };

  return (
    <div className="w-full">
      <div className={getGridClasses()}>
        {paymentMethodsList.map((method) => {
          return (
            <PaymentMethodCard
              key={method.method}
              method={method.method}
              config={method}
              isSelected={paymentMethod === method.method}
              onSelect={changePaymentMethod}
            />
          );
        })}
      </div>
    </div>
  );
};
